// extracted by mini-css-extract-plugin
export var chart = "ChartResults-module--chart--+Wew7";
export var deferral = "ChartResults-module--deferral--Dagny";
export var grid = "ChartResults-module--grid--zljZP";
export var root = "ChartResults-module--root--Lizw4";
export var taxable = "ChartResults-module--taxable--0jZLG";